module.exports = __webpack_public_path__ + "static/media/Moshi-Display.5b1fd1dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/Moshi-Display.png
// module id = 371
// module chunks = 0